import { tw } from 'twind';
import { useState } from 'react';

import { isAppOnlyProductItem } from 'utils/isAppOnlyProductItem';
import { useTranslate } from 'hooks/useTranslations';
import { ActiveCartItems } from 'types/cart';
import { isAppExclusiveValidRange } from 'utils/isAppExclusiveValidRange';
import { getAppOnlyDateTimes } from 'utils/getAppOnlyDateTimes';

import { ShoppingCartItem } from './ShoppingCartItem';

export type CartItemsProps = {
  basketId?: string;
  condensedView?: boolean;
  editableItems?: boolean;
  preventItemLinks?: boolean;
  products?: ActiveCartItems;
  errorHandling?: {
    updateError?: (s: string[]) => void;
    cartUpdateError?: string[];
    cartUpdateWarnings?: string[];
  };
};

export const CartItems = ({
  basketId,
  condensedView,
  editableItems,
  preventItemLinks,
  products = [],
  errorHandling,
}: CartItemsProps) => {
  const translate = useTranslate();
  const [updating, setUpdating] = useState(false);

  return (
    <ol
      id="cart-products"
      className="flex flex-col flex-grow"
      aria-label={translate('productList')}
    >
      {products?.map(cartItem => {
        const isBonusItem = !!(
          cartItem.__typename === 'ProductCartItem' && cartItem.bonusItemId
        );
        const isForAppItem = isAppOnlyProductItem(cartItem);
        const { from, to } = getAppOnlyDateTimes(cartItem);

        const allowUpdate =
          editableItems &&
          !isBonusItem &&
          !isAppExclusiveValidRange(isForAppItem, from, to);

        return (
          <li
            key={cartItem.id}
            className={tw([
              'mobile:pt-0',
              condensedView && '-mt-[1px] pt-0',
              !condensedView && 'pt-4',
            ])}
          >
            <ShoppingCartItem
              compact
              item={cartItem}
              basketId={basketId}
              allowRemove={editableItems}
              preventItemLinks={preventItemLinks}
              allowUpdate={allowUpdate}
              errorHandling={errorHandling}
              updating={updating}
              setUpdating={v => setUpdating(v)}
            />
          </li>
        );
      })}
    </ol>
  );
};
